import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import React from 'react';
import Popup from '../../../components/Popup';
export default (function (_ref) {
  var className = _ref.className,
      children = _ref.children,
      content = _ref.content,
      props = _objectWithoutProperties(_ref, ["className", "children", "content"]);

  return /*#__PURE__*/React.createElement(Popup, _extends({
    className: "cloud-ui-nav-popup ".concat(className),
    positionFixed: true,
    size: "small",
    popperModifiers: [{
      name: 'preventOverflow',
      options: {
        boundariesElement: 'offsetParent'
      }
    }],
    content: /*#__PURE__*/React.createElement(Popup.Content, {
      content: content
    }, children)
  }, props));
});